import {FC} from 'react'
import {useTranslation} from 'react-i18next'

type ICallbackFunction = (value: string) => void

const CompareButton: FC<{
    selected: number
    setActiveTab: ICallbackFunction
}> = ({selected, setActiveTab}) => {
    const {t} = useTranslation()

    return selected > 0 ? (
        <>
            <a href="#fund-list" className="btn-copmparison btn-text flex active" onClick={() => setActiveTab('compared')}>
                {t('label.catalog.btn.compare', {count: selected})}
            </a>
            {/*<button className="btn-copmparison btn-text active" onClick={() => setActiveTab('compared')}>*/}
            {/*    {t('label.catalog.btn.compare', {count: selected})}*/}
            {/*</button>*/}
        </>
    ) : (
        <>
            <button className="btn-copmparison btn-text">{t('label.catalog.btn.compare', {count: selected})}</button>
        </>
    )
}

export default CompareButton
